export const getPaymentInputName = ({ base, isSplit, isFirst }) => {
	if (!isSplit) {
		return base;
	}

	return base + (isFirst ? 'First' : 'Second');
};
